import {Injectable} from '@angular/core';
import { Http, Response,Headers } from '@angular/http';
import {Product} from '../classes/product';
import {BehaviorSubject, Observable, Subject, Subscriber} from 'rxjs';
import { map } from 'rxjs/operators';
import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
@Injectable()
export class ProductsService {
  public editaddressvalue: any;
  public data: Product[];
  public dataimg: Product[];
  images: string;
  public dynamicbrandset = [];
  public dynamictempdata = [];
  public dynamiclifestageset = [];
  public dynamicflavourset = [];
  mfstatus = 0;
   headerss = new Headers({
    "Accept": "application/json",
    "Content-Type": "application/x-www-form-urlencoded",
    "Authorization": this.getClientGrant(),
   });
  public dynamicbrandpipe = new BehaviorSubject<number>(this.mfstatus);
  dynamicbrandpipevalue = this.dynamicbrandpipe.asObservable();
  public productroute = new BehaviorSubject<number>(this.mfstatus);
  productroutechange = this.productroute.asObservable();

  private cdtk= "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjZlOWVlZDVjODQ5Yzk1YTVlNjIwYTUyMDMwMTYyMDJiOTBmYzAxNzRkMzA3NDc0OTc1ZmFlMDgyNDdkMGNhNjdiNmFhMzIzM2NmMjgyYjA0In0.eyJhdWQiOiIzIiwianRpIjoiNmU5ZWVkNWM4NDljOTVhNWU2MjBhNTIwMzAxNjIwMmI5MGZjMDE3NGQzMDc0NzQ5NzVmYWUwODI0N2QwY2E2N2I2YWEzMjMzY2YyODJiMDQiLCJpYXQiOjE1MzE0MDA3MjcsIm5iZiI6MTUzMTQwMDcyNywiZXhwIjoxNTYyOTM2NzI3LCJzdWIiOiIiLCJzY29wZXMiOltdfQ.dz0LSq7-jtxzrLmH6KgrNFGBYYq7UHf9n10owKt1JSoUdoLiCJJEmTprHufPiBrzu_6FxwivAUW5gD6yCQicAeVvxqBk1V3lNJduKt8TrCqeJWhqlECRvPp-fRJsbh3ZxsPwysKrAlb2AeWBv_NowO7nRyB4IpUiTatmV_Ud41WdM_pW-hBdJGLlX8-m5wHRYGOyMQay257byTtqOtJHVpouZd8b3Itta2uVX4cVaGgtTosebKfuLYG_xs5yLGMXXuab8pL2e5IdhYsYe1WJ0n-1qUK0ZH26WyLBZzEQ7s7DR3HGJN_YfBRLEDRmphvnYxBeAfiKtl1G4ztFSOksG5Qwxq-YugCODot_AmiNvUVxqRumgzegyx-xJN-Xc7ATbghFQ9iJwpLRiiqbQrFtsAe8eB6dLMpQ-mV4wFqZp51EQtAViW0LL9Rb9z1pghaMhBdurNyKCr5r-dMgI8fPAUd5iEQ8lloz-BJ_dowSiotHiPMNgpQOuQ_3lMKZyWs9UGxyCzCJ5g52Pe28Qvd8KLZ5uyI6pOQZNBRHGD0QRjn9erW3tDGDWx-Teba77YiLlpGjpX9zxbruEun0n3BlorGX7QEncW9riLorDC8OnWPNvgL1Iu1d1sEYYFKdfJETfrBCcrDWjexHWtbBtZZEthztq1wPiqbtOw5INiTjV6Q";
  clientcredentialheader = new Headers({'Content-Type':'application/json',
  'Accept':'application/json', 'X-Requested-With': 'XMLHttpRequest',
  'Authorization': this.getClientCredential()});
   authcredheader: any;
  constructor(private http: Http,@Inject(PLATFORM_ID) private platformId: Object) {}
  getClientCredential(){
    var Bearer= 'Bearer' + ' ' + this.cdtk;
    return Bearer;
  }
getAuthCredential(){
  if (isPlatformBrowser(this.platformId)) {
    var a = localStorage.getItem("token");
    var tjson =JSON.parse(a);
    if(tjson != null){
      var auth= 'Bearer' + ' ' +  tjson.token;
      return auth;
    }
  }
  }
  genAuthHeader(){
    this.authcredheader = new Headers({'Content-Type':'application/json',
    'Accept':'application/json', 
    'Authorization': this.getAuthCredential()})
  }
  getClientGrant() {
    if (isPlatformBrowser(this.platformId)) {
    const gdata = localStorage.getItem('cgi');
    const gjson = JSON.parse(gdata);
    if (gjson != null) {
      const cgi = 'Bearer'+ ' '+ atob(gjson.cgi);
      return cgi;
    }
  }
 }
  public setDynamicbrandset(result) {
    this.dynamicbrandset = result;
  }
  public getDynamicbrandset() {
    return this.dynamicbrandset;
   }
   public setDynamiclifestageset(result) {
    this.dynamiclifestageset = result;
  }
  public getDynamiclifestageset() {
    return this.dynamiclifestageset;
   }
   public setDynamicdataset(result) {
    this.dynamictempdata = result;
  }
  public getDynamicbdataset() {
    return this.dynamictempdata;
   }
   public setDynamicflavourset(result) {
    this.dynamicflavourset = result;
  }
  public getDynamicflavourset() {
    return this.dynamicflavourset;
   }
   public setEditaddressvalue(add) {
     this.editaddressvalue = add;
   }
   public getEditaddressvalue() {
     return this.editaddressvalue;
   }
  getProducts() {
    return this.http.get('https://passport.petcart.in/products?getall=1&status=1',
  {headers: this.clientcredentialheader})
    .pipe(map(
      (response: Response) => {
        return response.json().data;
      })
    );
  }
  getStaticData(){
    return this.http.get('https://passport.petcart.in/staticdata',
    {headers: this.clientcredentialheader})
    .pipe(map(
      (response: Response) => {
        return response.json().data;
      })
    );
    }

  getProductsByBrand(bid) {
    return this.http.get('https://passport.petcart.in/products?getall=1&status=1&brand_id=' + bid,
    {headers: this.clientcredentialheader})
    .pipe(map(
      (response: Response) => {
        return response.json().data;
      })
    );
  }
  getProductsByLifestageKitten(lid) {
    return this.http.get('https://passport.petcart.in/categories/'+lid+'/products?status=1',
    {headers: this.clientcredentialheader})
    .pipe(map(
      (response: Response) => {
        return response.json().data;
      })
    );
  }
  getProductsByLifestagePuppy(lid){
    return this.http.post('https://passport.petcart.in/lifestagecatproduct',
    {category_id: lid, lifestage_id: 3},
    {headers: this.clientcredentialheader})
    .pipe(map(
      (response: Response) => {
        return response.json();
      })
    );
  }
  getFoodProductsByLifestageKitten(lid){
    return this.http.post('https://passport.petcart.in/lifestagecatproduct',
    {category_id: lid, lifestage_id: 4},
    {headers: this.clientcredentialheader})
    .pipe(map(
      (response: Response) => {
        return response.json();
      })
    );
  }
  getParentId(cid) {
    return this.http.get('https://passport.petcart.in/categories?id=' + cid,
    {headers: this.clientcredentialheader})
    .pipe(map(
      (response: Response) => {
        return response.json().data;
      })
    );
  }
  getSimilerproduct(pcid) {
    return this.http.get('https://passport.petcart.in/categories?parentcatid=' + pcid,
    {headers: this.clientcredentialheader})
    .pipe(map(
      (response: Response) => {
        return response.json().data;
      })
    );
  }
  public getcatProduct(id: number) {
    return this.http.post('https://passport.petcart.in/categoryproduct',
    {category_id: id},
    {headers: this.clientcredentialheader})
    .pipe(map(
      (response: Response) => {
        return response.json();
      })
    );
  }




  public getProduct(id: number) {
    return this.http.get('https://passport.petcart.in/products/'+ id,
    {headers: this.clientcredentialheader})
      .pipe(map(
        (response: Response) => {
          return response.json().data;
        })
      );
  }


  public getProductimage(id: number) {
    return this.http.get('https://passport.petcart.in/products?id=' + id,
    {headers: this.clientcredentialheader})
      .pipe(map(
        (response: Response) => {
          return response.json().data;
        })
      );
  }
  public getProductimagebySku(sku) {
    return this.http.get('https://passport.petcart.in/products?sku=' + sku,
    {headers: this.clientcredentialheader})
      .pipe(map(
        (response: Response) => {
          return response.json().data;
      })
      );
  }
  getFeatureProduct() {
    const flag = 1;
    return this.http.get('https://passport.petcart.in/products?sort_bydesc=updated_at&isfeatured=' + flag,
    {headers: this.clientcredentialheader})
    .pipe(map(
      (response: Response) => {
        return response.json().data.slice(0, 10);
      })
    );
  }
  getNewProduct() {
    const flag = 1;
    return this.http.get('https://passport.petcart.in/products?sort_bydesc=updated_at&isnew=' + flag,
    {headers: this.clientcredentialheader})
    .pipe(map(
      (response: Response) => {
        return response.json().data.slice(0, 10);
      })
    );
  }
  getSellingproducts() {
    return this.http.get('https://passport.petcart.in/products?sort_bydesc=updated_at&status=' + status,
    {headers: this.clientcredentialheader})
    .pipe(map(
      (response: Response) => {
         return response.json().data;
      })
    );
  }
  getbrandDetail(bid) {
    return this.http.get('https://passport.petcart.in/brands/' + bid,
    {headers: this.clientcredentialheader})
    .pipe(map(
      (response: Response) => {
         return response.json().data;
      })
    );
  }
  getowncategorydetail(cid) {
    return this.http.get('https://passport.petcart.in/categories/' + cid,
    {headers: this.clientcredentialheader})
    .pipe(map(
      (response: Response) => {
         return response.json().data;
      })
    );
  }

  updatePayStatus(oid, cod) {
    this.genAuthHeader();
   return this.http.put('https://passport.petcart.in/orders/' + oid,
   {payment_mode: cod},
   {headers: this.authcredheader})
    .pipe(map(
   (response: Response) => response.json().data
  ));
  }

  public getOrderitems(sku, name) {
    return this.http.get('https://passport.petcart.in/products?sku=' + sku + '&name=' + name,
    {headers: this.clientcredentialheader})
      .pipe(map(
        (response: Response) => {
          return response.json().data;
        })
      );
  }

  getBrands(): Observable<any>{
    return this.http.get('https://passport.petcart.in/brands',
     {headers: this.clientcredentialheader})
    .pipe(map(
     (response: Response) =>{
       return response.json().data;
     })
     );
     }

     updateCartPrices(id, price, splprice, discount, payable){
      return this.http.put('https://passport.petcart.in/cartitems/' + id,
      { mrp: price, discprice: splprice, discount: discount, payable: payable},
      {headers: this.clientcredentialheader})
       .pipe(map(
      (response: Response) => response.json().data
     ));
    }
}
